import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export interface TaggableUser {
  id: string;
  groupName: string;
  name: string;
}

export type TaggableUserOption = TaggableUser & { display: string };

/** The resource whose participants can be tagged. */
export type TaggableUserResource = {
  resourceType: 'LocationEpisode' | 'Review';
  resourceId: string;
};

/** Tag on the participants of a review. Returns undefined when there is no
 * review yet, which leaves the caller's default in place. */
export const taggableUsersOnReview = (reviewId: string | undefined): TaggableUserResource | undefined =>
  reviewId ? { resourceType: 'Review', resourceId: reviewId } : undefined;

/** Tag on the participants of a location episode. */
export const taggableUsersOnLocationEpisode = (
  locationEpisodeId: string | undefined
): TaggableUserResource | undefined =>
  locationEpisodeId ? { resourceType: 'LocationEpisode', resourceId: locationEpisodeId } : undefined;

type IndexParams = TaggableUserResource & BaseIndexQueryParams;

export async function indexTaggableUsers(params: IndexParams, signal: GenericAbortSignal) {
  return http.get<Paginated<TaggableUser>>('taggable_users', { params, signal }).then((res) => ({
    ...res.data,
    data: res.data.data.map<TaggableUserOption>((user) => ({
      ...user,
      display: `${user.name} - ${user.groupName}`,
    })),
  }));
}
